import React, { lazy, Suspense } from "react";
import { LazyLoader } from "../../../../assets/loaders";

const LazyComponent = lazy(() => import("./AuditTrailsMain"));

export default function AuditTrail() {
  return (
    <Suspense fallback={<LazyLoader />}>
      <LazyComponent />
    </Suspense>
  );
}
